import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";

import {BasicBitmapCountUp} from "../components/BasicBitmapCountUp";
import {gsap} from 'gsap';
import {Game} from "../Game";
import {GameAssets} from "../GameAssets";
import {IWinRatioConfig} from "../interfaces/Interface";
import {GameFeatureMode} from "../enums/Enum";

export class TotalWinView extends PIXI.Container implements StageLayer {

    public showEndTl: gsap.core.Timeline;
    private _totalWinCountUp: BasicBitmapCountUp;
    private _mainTl: gsap.core.Timeline;
    private _shouldPlayCountUpEnd: boolean = true;

    constructor() {
        super();
        this.name = "TotalWinView";
        this.init();
    }

    public getTotalWinTimeline(totalWin: number): gsap.core.Timeline {
        this._mainTl = new gsap.core.Timeline();
        if (this._mainTl && this._mainTl.isActive()) {
            this._mainTl.pause();
            this._mainTl.kill();
        }
        const isWinBelowStake: boolean = (Game.model.data.mode !== GameFeatureMode.NORMAL && Game.model.data.mode !== GameFeatureMode.RESPIN) ? Game.isSingleWinBelowStake() : Game.isWinBelowStake();
        if (isWinBelowStake) {
            this._totalWinCountUp.visible = false;
            this._shouldPlayCountUpEnd = false;
            return this._mainTl;
        }
        const winRatioConfig: IWinRatioConfig = Game.model.winRatioConfig;
        this._mainTl.add(() => {
            this._totalWinCountUp.visible = true;
            this._shouldPlayCountUpEnd = true;
        }, 0);

        if (winRatioConfig.duration === 0) {
            this._mainTl.add(this._totalWinCountUp.getCountAnimation(totalWin, totalWin, winRatioConfig.duration));
            this._mainTl.add(() => {
                this._totalWinCountUp.alpha = 1;
                Game.winWaysView.showTotalWinWaysItems(false);
                Game.soundPlayer.stopCountUp();
            }, 0);
        } else {
            this._mainTl.add(() => {
                Game.soundPlayer.startCountUp(winRatioConfig.type);
            }, 0);
            this._totalWinCountUp.alpha = 0;
            this._mainTl.to(this._totalWinCountUp, {
                duration: 0.2,
                alpha: 1,
                ease: "power3.out"
            }, 0);
            this._mainTl.add(this._totalWinCountUp.getCountAnimation(0, totalWin, winRatioConfig.duration), 0);
            this._mainTl.add(() => {
                Game.winWaysView.showTotalWinWaysItems(false);
                this._totalWinCountUp.stopAt(totalWin);
                Game.soundPlayer.stopCountUp();
            });
        }
        this.showEndTl = new gsap.core.Timeline({paused: true});
        this.showEndTl.to({}, {duration: 1});
        this.showEndTl.add([
                gsap.to(this._totalWinCountUp, {
                    duration: 0.2,
                    alpha: 0,
                    ease: "power3.out",
                }),
                Game.winWaysView.hideTotalWinWaysItems(0.2)
            ]
        );

        this.showEndTl.add(() => {
            this._totalWinCountUp.visible = false;
            this._totalWinCountUp.alpha = 1;
        });
        if(Game.model.gameData.nextMode === GameFeatureMode.NORMAL){
            this._mainTl.add(() => {
                this._shouldPlayCountUpEnd = false;
                this.showEndTl.play();
            });
        }else{
            this._mainTl.add(() => {
                this._shouldPlayCountUpEnd = false;
            });
            this._mainTl.add(this.showEndTl.play());
        }

        return this._mainTl;
    }

    public hardAbort(totalWin: number): void {
        if (this._mainTl) {
            this._mainTl.pause();
            this._mainTl.kill();

            // #362 -> this._shouldPlayCountUpEnd is false in belowWinStake cases in this file.
            if (this._shouldPlayCountUpEnd) {
                Game.soundPlayer.stopCountUp();
                this._shouldPlayCountUpEnd = false;

                this._totalWinCountUp.alpha = 1;
                this._totalWinCountUp.visible = true;
                this._totalWinCountUp.stopAt(totalWin);
                Game.winWaysView.showTotalWinWaysItems(false);
                gsap.delayedCall(0.3, () => {
                    Game.winWaysView.hideTotalWinWaysItems(0.2);
                });
                this.fadeOutWinPres(0.2, 0.3);
            }
        }
    }

    private fadeOutWinPres(duration: number, delay: number): void {
        const tl: gsap.core.Timeline = new gsap.core.Timeline({
            delay: delay
        });
        tl.to(this._totalWinCountUp, {
            duration: duration,
            alpha: 0,
            ease: "power3.out"
        });
        tl.add(() => {
            this._totalWinCountUp.visible = false;
        });
    }

    private init(): void {
        this._totalWinCountUp = new BasicBitmapCountUp({
            fontName: GameAssets.BITMAP_FONT_WIN_COUNT_UP,
            fontSize: 96,
        }, 420, new PIXI.Point(0.5, 0.5));
        this._totalWinCountUp.position.set(360);
        this._totalWinCountUp.visible = false;
        this.addChild(this._totalWinCountUp);
    }
}